<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListTextos";

export default {
  data() {
    return {
      subjectPermission: "Textos",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
